<dashboardnav>

  <cradua-incident-sub-category [incidentcategorys]="incidentcategorys$ | async"
    [incidentsubcategorys]="incidentsubcategorys$ | async" (changeEmit)="onSubmitIncidentSubCategory($event)"
    (deleteEvent)="onDeleteIncidentSubCategory($event)" *ngIf="
  !(isLoadingIncidentCategory$ | async ) &&
  !(isLoadingIncidentSubCategory$ | async )
  ">
  </cradua-incident-sub-category>

  <mrsoftapps-epims-reference-spinner *ngIf="
  (isLoadingIncidentCategory$ | async ) ||
  (isLoadingIncidentSubCategory$ | async )
  ">
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
